"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportableImageType = exports.ImageType = exports.RevisionDependantImageType = exports.ImageSize = void 0;
exports.isRevisionDependantImageType = isRevisionDependantImageType;
exports.ImageSize = {
    MEDIUM: 'medium',
    THUMBNAIL: 'thumbnail',
    RAW: 'raw',
    LARGE: 'large'
};
/**
 * These types are dependent on the collection state and thus the collectionRevision
 */
exports.RevisionDependantImageType = {
    CROP: 'crop',
    BRIGHTNESS: 'brightness',
    COMPOSITE: 'composite',
    MEASUREMENT: 'measurement'
};
function isRevisionDependantImageType(value) {
    return typeof value === 'string' && Object.values(exports.RevisionDependantImageType).includes(value);
}
exports.ImageType = {
    STANDARD: 'standard',
    CROP: 'crop',
    BRIGHTNESS: 'brightness',
    COMPOSITE: 'composite',
    MEASUREMENT: 'measurement'
};
exports.ExportableImageType = {
    COMPOSITE: 'composite',
    MEASUREMENT: 'measurement',
    STANDARD: 'standard'
};
//# sourceMappingURL=image.js.map